import {EDeviceCategory, hasEnv} from "dyna-detect-env";

export const isDesktop: boolean = hasEnv(EDeviceCategory.desktop);